module.exports = __webpack_public_path__ + "assets/omv-9522c4d6284e0937bcd85ccf283a2344.svg";